{
  "version": 1,
  "asset_id": "249578c8-ce8f-49bf-b3db-e2f32c3f22a0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/249578c8-ce8f-49bf-b3db-e2f32c3f22a0/gastric-bypass-es-v2-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/249578c8-ce8f-49bf-b3db-e2f32c3f22a0/gastric-bypass-es-v2-800.jpg",
  "original_filename": "gastric-bypass-es-v2-800.jpg",
  "size": 62524,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:00:44Z"
}
